import React, { useEffect, useState } from "react";
import { TrackStudentsHeader } from "./utils";
import TableComponent from "components/TableComponent";
import ListingHeaderComponent from "components/ListingHeaderComponent";
import { useLocation } from "react-router-dom";
import TrackStudentActions from "./TrackStudentActions";
import { CallAPI } from "actions/General";
import LoaderComponent from "components/LoaderComponent";
import CustomModal from "components/CustomModal";
import AwardCredits from "./AwardCredits";

function TrackStudents() {
  const location = useLocation();
  const [trackStudents, setTrackStudents] = useState([]);
  const [loader, setLoader] = useState(false);
  const [loaderType, setLoaderType] = useState("");
  const [apiError, setApiError] = useState("");
  const [error, setError] = useState("");
  const [awardCreditsObj, setAwardCreditsObj] = useState(null);

  const fetchScheduleDetails = async () => {
    setLoaderType("get_listing");
    try {
      let result = await CallAPI(
        "FETCH_SCHEDULE_DETAILS",
        null,
        location.state.meeting_id,
        setLoader,
        setApiError,
        null
      );
      if (result.status) {
        console.log(result.data);
        setTrackStudents(result.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchScheduleDetails();
  }, []);

  const awardCredits = (data) => {
    if (data.enrollment_id) {
      setAwardCreditsObj(data);
    } else {
      setError("user_has_not_this_enrollment");
    }
  };
  const closeErrorModal = () => {
    setApiError("");
    setError("");
  };
  return (
    <>
      {loader && loaderType === "get_listing" && (
        <LoaderComponent classes={"mx-4"} />
      )}
      <div className="card mb-4">
        <ListingHeaderComponent
          type={"track_students"}
          setDisplayType={TrackStudentActions}
          displayType={""}
        />

        <div className={"card-body py-4"}>
          <TableComponent
            data={trackStudents}
            header={TrackStudentsHeader}
            type="track_students"
            props={{
              awardCredits: awardCredits,
            }}
          />
        </div>
      </div>
      {awardCreditsObj && (
        <AwardCredits
          AwardCreditsObj={awardCreditsObj}
          setAwardCreditsObj={setAwardCreditsObj}
          fetchScheduleDetails={fetchScheduleDetails}
        />
      )}
      {(apiError || error) && (
        <CustomModal
          header={""}
          text={apiError || error}
          buttons={[
            {
              text: "ok",
              variant: "blue-1",
              onClick: "closeErrorModal",
              loading: false,
              disabled: false,
            },
          ]}
          onClose={closeErrorModal}
          variant={"error"}
          functionsList={{ closeErrorModal }}
        />
      )}
    </>
  );
}

export default TrackStudents;
